import { createSlice } from 'utils/@reduxjs/toolkit';
import { ErrorNotifyState } from './types';
import { reducers } from './reducers';

export const initialState: ErrorNotifyState = {
  data: {
    show: false,
  },
};

const slice = createSlice({
  name: 'errorNotify',
  initialState,
  reducers,
});

export const { actions: errorNotifyActions } = slice;
export const { reducer: errorNotifyReducer } = slice;
